<div class="ca-membership-card"
  [ngClass]="{'silver': cardData?.level == 'Silver', 'loginCard': loginCard == true, 'homeCard': homeCard == true, 'membCard': membCard == true, 'walletCard': walletCard == true, 'termsCard': termsCard == true, 'benefitCard': benefitCard == true}">
  <div class="ca-memb-card" [style.backgroundImage]="'url(' + cardImage +')'">
    <div class="ca-memb-hotel__details">
      <div class="ca-member">
        <div class="ca-memb__particulars">
          <ion-avatar class="ca-memb__photo" *ngIf="showUserImg">
            <ion-img [alt]="altTags.profilePic" [src]="'assets/imgs/spouseMembIcon.png'" *ngIf="!isImageLoaded"></ion-img>
            <ion-img [alt]="altTags.profilePic" [src]="showUserImg" [style.opacity]="isImageLoaded ? 1 : 0" (ionImgWillLoad)="imageloading()">
            </ion-img>
          </ion-avatar>
          <ng-container *ngIf="!showUserImg "> 
            <input type='file'  accept=".png, .jpg, .jpeg" (change)="onFileChange($event)" hidden #fileInput>
          <img [alt]="altTags.profilePic" src="assets/icon/useruploadicon.svg" class="ca-memb__photo" (click)="ChangeProfilePic(fileInput)"
            *ngIf="!showUserImg && homeCard" />
            <!-- <input type="file" accept="image/*" id="file-input" capture /> -->
           
          <img src="assets/imgs/spouseMembIcon.png" class="ca-memb__photo"
            *ngIf="!showUserImg && (membCard || benefitCard || termsCard || walletCard || loginCard)" />
          </ng-container> 
          <div class="ca-memb__details" (click)="goToMembershipFunc()">
            <div class="ca-memb__name">{{cardData?.memberFirstName}} {{cardData?.memberLastName}}
              <span *ngIf="cardData?.highestSpender && loginCard"><img class="starImg"
                  src="assets/imgs/star.png"></span>
            </div>
            <div class="ca-memb__ID"
              *ngIf="(cardType != 'expiredCard')&&(cardType != 'visitor')&&(cardType != 'cardExpired') && !walletCard">
              {{membershipNumber}}
            </div>
            <ng-container *ngIf="walletCard">
              <div class="ca-memb__ID"> {{membershipNumber}} </div>
            </ng-container>
          </div>
        </div>
        <ng-container *ngIf="homeCard || walletCard">
          <div [ngSwitch]="cardType">
            <div *ngSwitchCase="'aboutToExpireCard'" class="ca-memb__progress">
              <div class="ca-memb__progress-inner" [style.width]="expiryProgress + '%'"></div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <ng-container *ngIf="homeCard || loginCard">
      <div [ngSwitch]="cardType" class="ca-memb__expiry-details">
        <div *ngSwitchCase="'aboutToExpireCard'" (click)="navigateToActivation(staticContent.renew_Membership)"
          class="ca-memb__expiry">
          <div class="ca-memb__expiry-detail-msg">
            <ion-icon class="ca-reactive-membership ca-memb__expired-icon"></ion-icon>
            <div class="ca-memb__expiry-time">{{diffDays}} {{'membership_home.expiry'| translate}}</div>
          </div>
          <div class="ca-memb__renew">
            <div class="ca-memb__renew-link">{{'membership_home.renew_Now'| translate}} </div>
            <ion-icon class="ca-right-arrow-icon ca-memb__renew-link-arrow"></ion-icon>
          </div>
        </div>
        <div *ngSwitchCase="'validCard'" class="ca-memb__expiry">
          <ng-container *ngIf="isMembershipYetToStart; else membershipStarted">
            <div class="ca-memb__level pr-0">{{ "activitiesTab.startDate" | translate }} {{cardData?.startFrom | date: "dd/MM/yyyy"}}</div>
            <div class="ca-memb__expiry-date pl-0">{{ "activitiesTab.endDate" | translate }} {{membershipEndDate}}</div>
          </ng-container>
          <ng-template #membershipStarted>
            <div class="ca-memb__level pr-0">{{cardData?.level}}</div>
            <div class="ca-memb__expiry-date pl-0"> {{cardData?.validThruShow}} </div>
          </ng-template>
        </div>
        <div *ngSwitchCase="'expiredCard'" (click)="navigateToActivation(staticContent.reactivate_Membership)"
          class="ca-memb__expired-card">
          <div class="ca-memb__expired-msg">
            <ion-icon class="ca-reactive-membership ca-memb__expired-icon"></ion-icon>
            <div class="ca-memb__renew-msg"> {{'membership_home.reactivate_Membership'| translate:brandName}} </div>
          </div>
          <ion-icon class="ca-memb__renew-icon ca-right-arrow-icon"></ion-icon>
        </div>
        <div *ngSwitchCase="'visitor'" class="ca-memb__expired-card" (click)="navigateToActivation('visitor')">
          <div class="ca-memb__expired-msg">
            <ion-icon class="ca-reactive-membership ca-memb__expired-icon"></ion-icon>
            <div class="ca-memb__renew-msg"> {{'membership_home.visitor_card'| translate:brandName}} </div>
          </div>
          <ion-icon class="ca-memb__renew-icon ca-right-arrow-icon"></ion-icon>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="walletCard">
      <div [ngSwitch]="cardType" class="ca-memb__expiry-details">
        <div class="ca-memb__expiry">
          <ng-container *ngIf="isMembershipYetToStart; else membershipStarted">
            <div class="ca-memb__level pr-0">{{ "activitiesTab.startDate" | translate }} {{cardData?.startFrom | date: "dd/MM/yyyy"}}</div>
            <div class="ca-memb__expiry-date pl-0">{{ "activitiesTab.endDate" | translate }} {{membershipEndDate}}</div>
          </ng-container>
          <ng-template #membershipStarted>
            <div class="ca-memb__level pr-0">{{cardData?.level}}</div>
            <div class="ca-memb__expiry-date pl-0"> {{cardData?.validThruShow}} </div>
          </ng-template>
        </div>
        <div *ngSwitchCase="'visitor'" class="ca-memb__expired-card" (click)="navigateToActivation('visitor')">
          <div class="ca-memb__expired-msg">
            <ion-icon class="ca-reactive-membership ca-memb__expired-icon"></ion-icon>
            <div class="ca-memb__renew-msg"> {{'membership_home.visitor_card'| translate:brandName}} </div>
          </div>
          <ion-icon class="ca-memb__renew-icon ca-right-arrow-icon"></ion-icon>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="membCard || termsCard">
      <div [ngSwitch]="cardType" class="ca-memb__expiry-details">
        <div *ngSwitchCase="'validCard'" class="ca-memb__expiry">
          <ng-container *ngIf="isMembershipYetToStart; else membershipStarted">
            <div class="ca-memb__level pr-0">{{ "activitiesTab.startDate" | translate }} {{cardData?.startFrom | date: "dd/MM/yyyy"}}</div>
            <div class="ca-memb__expiry-date pl-0">{{ "activitiesTab.endDate" | translate }} {{membershipEndDate}}</div>
          </ng-container>
          <ng-template #membershipStarted>
            <div class="ca-memb__level pr-0">{{cardData?.level}}</div>
            <div class="ca-memb__expiry-date pl-0"> {{cardData?.validThruShow}} </div>
          </ng-template>
        </div>
        <div *ngSwitchCase="'visitor'" class="ca-memb__expired-card" (click)="navigateToActivation('visitor')">
          <div class="ca-memb__expired-msg">
            <ion-icon class="ca-reactive-membership ca-memb__expired-icon"></ion-icon>
            <div class="ca-memb__renew-msg"> {{'membership_home.visitor_card'| translate:brandName}} </div>
          </div>
          <ion-icon class="ca-memb__renew-icon ca-right-arrow-icon"></ion-icon>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="benefitCard">
      <div [ngSwitch]="cardType" class="ca-memb__expiry-details">
        <div *ngSwitchCase="'validCard'" class="ca-memb__expiry">
          <div class="ca-memb__level" (click)="goToTerms($event)">{{'cardBenefit.terms' | translate}}&nbsp;></div>
          <div class="ca-memb__expiry-date qr-wrap">
            <span class="visibility-hidden"></span>
            <img class="qr-img" [src]="qrScanner">
          </div>
        </div>
      </div>
    </ng-container>

  </div>
</div>